import styled from 'styled-components';

export default styled.div`
  .isoBoxWrapper {
    background: none;
    border: none;
    padding-top: 0;
    padding: 0px;
    .order-info-section {
      background: #fff;
      padding: 24px;
      min-width: 70%;
    }
    .drawerContainer {
      .content {
        padding: 0;
        .action-row {
          width: 100%;
          display: flex;
          justify-content: flex-end;
          margin-top: 30px;
          .ant-btn {
            width: 100%;
          }
        }
        .order-content {
          display: flex;
          flex-direction: column;
        }
      }
    }
  }
`;
